module.exports = __webpack_public_path__ + "img/tag-bottom-2x.2a392ee.png";